export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';

export const TIMEOUT_SEC = 10;

export const RES_PER_PAGE = 10;

export const KEY = '57b3b74e-9353-47e1-8561-f21f523d3cad';

export const MODAL_CLOSE_SEC = 2.5;
